// Cookie consent preference, stored client-side (localStorage, not a cookie)
// so remembering the choice itself never requires consent. The site
// currently sets no tracking/analytics/marketing cookies at all — this is
// the hook future code should check before loading anything that would
// (e.g. Google Analytics): `if (hasConsent('analytics')) { ...load GA... }`.
const CONSENT_KEY = "rs_cookie_consent";
export const CHANGE_EVENT = "rs-cookie-consent-changed";

// null = no choice made yet (banner should show)
// "all" = necessary + analytics/marketing
// "necessary" = only strictly necessary
// "none" = declined everything non-essential
export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch (e) {
    return null;
  }
}

export function setConsent(level) {
  try {
    localStorage.setItem(CONSENT_KEY, level);
  } catch (e) {}
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { level } }));
}

// category: "analytics" | "marketing" — both currently map to the same
// "all" tier since the site has no distinct cookie categories yet.
export function hasConsent(category) {
  return getConsent() === "all";
}
